import { configureStore } from "@reduxjs/toolkit";

import { authReducer } from "./auth.slice";
import { userReducer } from "./users.slice";
import { masterReducer } from "./master.slice";
import { warehouseReducer } from "./warehouse.slice";
import { vendorReducer } from "./vendor.slice";
import { categoryReducer } from "./category.slice";
import { subCategoryReducer } from "./subCategory.slice";
import { changepasswordReducer } from "./changepassword.slice";
import { attributeReducer } from "./attribute.slice";
import { productReducer } from "./product.slice";
import { clientReducer } from "./client.slice";
import { termReducer } from "./term.slice";
import { stockManagementReducer } from "./stockManagement.slice";
import { inventoryHistoryReducer } from "./inventoryHistory.slice";
import { orderReducer } from "./order.slice";
import { dashboardReducer } from "./dashboard.slice";
import { productStockReducer } from "./productStock.slice";
import {courierReducer} from "./courier.slice";

export * from "./auth.slice";
export * from "./users.slice";
export * from "./master.slice";
export * from "./warehouse.slice";
export * from "./vendor.slice";
export * from "./category.slice";
export * from "./subCategory.slice";
export * from "./changepassword.slice";
export * from "./attribute.slice";
export * from "./product.slice";
export * from "./client.slice";
export * from "./term.slice";
export * from "./stockManagement.slice";
export * from "./inventoryHistory.slice";
export * from "./order.slice";
export * from "./dashboard.slice";
export * from "./productStock.slice";
export * from "./courier.slice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    master: masterReducer,
    warehouse: warehouseReducer,
    vendor: vendorReducer,
    category: categoryReducer,
    subCategory: subCategoryReducer,
    changepassword: changepasswordReducer,
    attribute: attributeReducer,
    product: productReducer,
    client: clientReducer,
    term: termReducer,
    stockManagement: stockManagementReducer,
    inventoryHistory: inventoryHistoryReducer,
    order: orderReducer,
    dashboard: dashboardReducer,
    productStock: productStockReducer,
    courier:courierReducer
  },
  middleware: getDefaultMiddleware => 
    getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 64,  // Increase the threshold to 64ms
      },
    }),
});
